<template>
  <a-card
    :bordered="false"
    class="header-solid h-full"
    :bodyStyle="{ padding: 0 }"
  >
    <a-form layout="inline" :form="dataForm" @submit="getDataList" class="p-20">
      <a-form-item label="客户姓名">
        <a-input
          v-model="dataForm.customer_name"
          placeholder="请输入客户姓名"
        ></a-input>
      </a-form-item>
      <a-form-item label="客户手机号">
        <a-input
          v-model="dataForm.customer_phone"
          placeholder="请输入客户手机号"
        ></a-input>
      </a-form-item>
      <a-form-item label="是否入会">
        <a-select
          v-model="dataForm.vip"
          style="width: 120px"
          placeholder="请选择"
          allowClear
        >
          <a-select-option value="1"> 已入会 </a-select-option>
          <a-select-option value="2"> 未入会 </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          @click="receive"
          :disabled="selectedRowKeys.length == 0"
          >领取</a-button
        >
      </a-form-item>
    </a-form>
    <a-table
      :columns="columns"
      :data-source="dataList"
      :pagination="false"
      :rowKey="(row) => row.customer_id"
      :loading="dataListLoading"
      filterMultiple
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
      <template slot="customer_name" slot-scope="customer_name, row">
        <a-button type="link" class="font-regular p-0 btn-edit">{{
          customer_name
        }}</a-button>
      </template>
      <template slot="grade" slot-scope="grade">
        <a-tag color="red" v-if="!!grade">{{ grade }}级</a-tag>
        <span v-else>未设置</span>
      </template>
      <template slot="vip" slot-scope="vip">
        <a-tag :color="vip == 1 ? 'green' : 'red'">{{
          vip == 1 ? "已入会" : "未入会"
        }}</a-tag>
      </template>
      <template slot="action" slot-scope="text, row">
        <a-button type="link" @click="CustomerDetail(row)"
          >查看客户档案</a-button
        >
      </template>
    </a-table>
    <a-pagination
      class="mr-20 float-right"
      show-size-changer
      :current="page"
      :total="total"
      :show-total="(total) => `共 ${total} 条数据`"
      @showSizeChange="showSizeChange"
      @change="pageCurrentChangeHandle"
    />
    <Customer ref="customer" @ok="query"></Customer>
  </a-card>
</template>

<script>
import viewModule from "@/mixins/view-module";
import Customer from "@/components/Customer/index.vue";
export default {
  mixins: [viewModule],
  components: {
    Customer,
  },
  data() {
    return {
      dataForm: {
        customer_name: "",
        customer_phone: "",
        grade: undefined,
        vip: undefined,
        customer_type: 4
      },
      selectedRowKeys: [],
      mixinViewModuleOptions: {
        getDataListURL: "/admin/customer/pagesea",
        deleteURL: "/admin/customer/delete",
      },
      columns: [
        {
          title: "姓名",
          dataIndex: "customer_name",
          // scopedSlots: { customRender: "customer_name" },
        },
        {
          title: "手机号",
          dataIndex: "customer_phone",
        },
        {
          title: "重要程度",
          dataIndex: "grade",
          scopedSlots: { customRender: "grade" },
        },
        {
          title: "是否入会",
          dataIndex: "vip",
          scopedSlots: { customRender: "vip" },
        },
        {
          title: "身份证号",
          dataIndex: "id_no",
        },
        {
          title: "性别",
          dataIndex: "gender_text",
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          fixed: "right",
        },
      ],
    };
  },
  methods: {
    CustomerDetail(row) {
      this.$refs.customer.init(row);
    },
    onSelectChange(selectedRowKeys) {
      console.log("selectedRowKeys changed: ", selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    //领取公海客户
    receive() {
      this.$confirm({
        title: "是否领取已勾选的客户?",
        content: (h) => (
          <div style="color:red;">领取后此客户将进入“我的客户”中</div>
        ),
        onOk: () => {
          this.$http({
            url: "/admin/customer/getcustomer",
            method: "post",
            data: {
              customer_ids: this.selectedRowKeys,
            },
          }).then(() => {
            this.$message.success("领取成功");
            this.getDataList();
          });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    },
  },
};
</script>

<style>
</style>